import { useEffect,  useState } from "react";
import { SearchOutlined, PlusOutlined } from '@ant-design/icons';
import {  Input } from "antd";
import { useOutletContext } from "react-router-dom";
import IsLoading from "../../common/isLoading";
import Card from "./card"

const Users = () => {
    const [filteredList, setFilteredList] = useState([]);
    const {refresh, isLoading, setIsLoading, userList, editUser, getUser} = useOutletContext();
    const [searchInput, setSearchInput] = useState('');

    useEffect(() => {
        Init();
    }, [refresh])

    const Init = async () => {
        setIsLoading(true);
        const response=await getUser();
        setFilteredList(response);
        setIsLoading(false);
    } 

    useEffect(() => {
        const query = (searchInput || "").toLowerCase();
        let searchedList = userList.filter(item =>
            (item.name || "").toLowerCase().includes(query) ||
            (item.username || "").toString().replace(/-/g, "").includes(query)
        );
        setFilteredList(searchedList);

    }, [searchInput])

    return (
        <div class="flex flex-col font-normal w-full h-screen bg-gray-100 relative" >

            {/* Header */}
            <div className="bg-teal-500 p-5 text-white  rounded-b-2xl sticky top-0 z-50 ">
                <div className="flex justify-between items-center mb-4">
                    <span> </span>
                    <h1 className="font-semibold text-lg">
                        Users
                    </h1>
                    <PlusOutlined size={22} className="cursor-pointer" onClick={() => editUser(0)} />
                </div>

                 <Input size="large" style={{ fontSize: 16 }} placeholder="Search" prefix={<SearchOutlined />} value={searchInput} onChange={(e) => setSearchInput(e.target.value)} allowClear />
          </div>

            {/* Content */}
            <IsLoading isLoading={isLoading} rows={10} input={
            <div className="p-4 space-y-4 overflow-y-auto h-[calc(100%-180px)]" >
                {
                filteredList.length ===0 ? 
                <div className="flex justify-between items-center mt-2 text-xs text-gray-400">
                        <span>No data found</span>
                        
                    </div> :
                filteredList.map((item) => (
                    <Card
                        id={item.id} 
                        user={item.username}
                        title={item.fullname}
                        status={item.status}
                        role={item.role}
                        modifiedat={item.modifiedat}
                        picture={item.picture}
                        editUser={editUser}
                       
                    />
                ))}
               
            </div>
            }/>           
        </div>
    )
}

export default Users